import { PaymentIntent } from '@/domain/stripe/invoice/model/PaymentIntent'

export class Payment {
  constructor(
    public readonly intent: PaymentIntent,
  ) {
  }
}